const OE_FIELD_MAP = [];

export default OE_FIELD_MAP;